module.exports = __webpack_public_path__ + "img/tab-hall-active.719d97b2.png";